module.exports = __webpack_public_path__ + "static/media/PCD225C.d49d8c47.png";